import { createContext } from 'react'
import { ModalPromptContextType } from './types'

export const ModalPromptContext = createContext<ModalPromptContextType>({
  // dummy implementations; we don't want to make all callers need to check for whether these are null by making them
  // optional in the context
  promptCustom: () => ({
    result: Promise.resolve(''),
    dismiss: () => {},
    enableChoice: () => {}
  }),
  promptWithOk: () => Promise.resolve(''),
  promptWithOkCancel: () => Promise.resolve(''),
  promptWithYesNo: () => Promise.resolve('')
})

export default ModalPromptContext
